<template>
  <v-card flat>
    <v-card-title class="title font-weigth-light px-0 py-0 mb-4">
      Asset Group Booking Details
    </v-card-title>
    <v-card-text class="px-0">
      <v-row>
        <v-col cols="4">
          <date-picker
            v-model="datePicker.start"
            :masks="datePicker.masks"
            :min-date="datePicker.minimum"
          >
            <template #default="{ inputValue, inputEvents }">
              <v-text-field
                :value="inputValue"
                label="From Date"
                v-on="inputEvents"
                outlined
                clearable
                :rules="[
                  v => {
                    if (!datePicker.end) return true;
                    return !!v || 'Start Date Required';
                  }
                ]"
                hide-details
              />
            </template>
          </date-picker>
        </v-col>
        <v-col cols="4">
          <date-picker
            v-model="datePicker.end"
            :masks="datePicker.masks"
            :min-date="datePicker.start"
          >
            <template #default="{ inputValue, inputEvents }">
              <v-text-field
                :value="inputValue"
                label="To Date"
                v-on="inputEvents"
                outlined
                clearable
                :rules="[
                  v => {
                    if (!datePicker.end) return true;
                    return !!v || 'End Date Required';
                  }
                ]"
                hide-details
              />
            </template>
          </date-picker>
        </v-col>
        <v-col cols="4">
          <v-combobox
            v-model="selectedAssetGroups"
            :items="assetGroups"
            item-text="name"
            item-value="id"
            label="Asset Group"
            multiple
            outlined
            required
            @change="changeAssetGroup; checkAllAssetGroup(false)"
          >
            <template #prepend-item>
              <v-list-item
                ripple
                @click="checkAllAssetGroup(true)"
              >
                <v-list-item-action class="mr-3">
                  <v-icon>{{ iconCheckAllAssetGroup }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ textCheckAllAssetGroup }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
            <template #selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1 && selectedAssetGroups.length > 1"
                class="grey--text caption"
              >
                (+{{ selectedAssetGroups.length - 1 }} Others)
              </span>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="py-0 d-flex justify-end"
        >
          <v-btn
            border
            color="primary"
            @click="generateReport"
          >
            Generate
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="isGenerate && data.length">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="data"
            class="font-weight-light pa-5"
            :loading="isLoading"
            loading-text="Loading"
            :footer-props="footerProps"
            :options.sync="paginationOptions"
          />
        </v-col>
      </v-row>
      <v-row v-if="isLoading">
        <v-col cols="12">
          <p class="text-center">
            Loading
          </p>
        </v-col>
      </v-row>
      <v-row v-if="isGenerate && !isLoading && data.length === 0">
        <v-col cols="12">
          <p class="text-center">
            No Data Found
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import get from "lodash/get";

export default {
  data() {
    return {
      assetGroups: [],
      selectedAssetGroups: [],
      datePicker: {
        start: '',
        startUnix: '',
        paramStart: '',
        end: '',
        endUnix: '',
        paramEnd: '',
        masks: {
          input: 'DD MMMM YYYY'
        },
      },
      headers: [
        { text: "Asset Group", value: "group" },
        { text: "Vehicle", value: "name" },
        { text: "Total Booking", value: "counter" },
      ],
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      data: [],
      isLoading: false,
      isGenerate: false,
      timeout: 0,
      textCheckAllAssetGroup: 'CHECK ALL ASSET GROUP',
      iconCheckAllAssetGroup: 'mdi-check-all',
    };
  },
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({
        assetGroups: [],
      }),
    },
  },
  mounted() {
    this.assetGroups = this.params.assetGroups;
  },
  watch: {
    "datePicker.start"(value) {
      const startDate = moment(value).format("YYYY-MM-DD");
      this.datePicker.paramStart = startDate;
    },
    "datePicker.end"(value) {
      const endDate = moment(value).format("YYYY-MM-DD");
      this.datePicker.paramEnd = endDate;
    },
  },
  computed: {
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
  },
  methods: {
    checkAllAssetGroup(force = false) {
      if (force) {
        if (this.textCheckAllAssetGroup === 'CHECK ALL ASSET GROUP') {
          this.selectedAssetGroups = this.assetGroups;
          this.textCheckAllAssetGroup = 'UNCHECK ALL ASSET GROUP';
          this.iconCheckAllAssetGroup = 'mdi-close';
        } else {
          this.selectedAssetGroups = [];
          this.textCheckAllAssetGroup = 'CHECK ALL ASSET GROUP';
          this.iconCheckAllAssetGroup = 'mdi-check-all';
        }
      } else {
        if (this.selectedAssetGroups.length === this.assetGroups.length) {
          this.textCheckAllAssetGroup = 'UNCHECK ALL ASSET GROUP';
          this.iconCheckAllAssetGroup = 'mdi-close';
        } else {
          this.textCheckAllAssetGroup = 'CHECK ALL ASSET GROUP';
          this.iconCheckAllAssetGroup = 'mdi-check-all';
        }
      }
    },
    changeAssetGroup() {
      this.selectedAssetGroups = this.selectedAssetGroups.filter((assetGroup) => typeof assetGroup === 'object' && assetGroup.id);
    },
    generateReport(vehicleId) {
      if (!this.selectedAssetGroups.length || !this.datePicker.start || !this.datePicker.end) return;
      if (this.selectedAssetGroups.length && this.datePicker.start && this.datePicker.end) {
        this.data = [];
        let selectedAssetGroupsId = null;
        if (typeof vehicleId !== 'object') {
          selectedAssetGroupsId = vehicleId;
        } else {
          this.selectedTab = 0;
          selectedAssetGroupsId = this.selectedAssetGroups[0].id;
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getDataBook(selectedAssetGroupsId);
        }, 500);
      }
    },
    getDataBook() {
      this.isLoading = true;
      const payload = {
        clientid: this.$store.state.clientid,
        start_date: this.datePicker.paramStart,
        end_date: this.datePicker.paramEnd,
        get_schedules: 1,
        get_recurring: 0,
      };
      if (this.isIntimap || this.isWSP) {
        payload.use_timezone_depot = 1;
      }
      return this.$store.dispatch('API_CALL', {
        $method: 'get_all_book',
        $postData: payload,
      })
      .then((response) => {
        this.data = response.data.data.filter((book) => {
          try {
            const metadata = JSON.parse(book.book_detail.metadata);
            return this.selectedAssetGroups.find((assetGroup) => assetGroup.id == metadata.booking_detail.group_id);
          } catch (e) {}
          return false;
        }).reduce((arr, value) => {
          const metadata = JSON.parse(value.book_detail.metadata);
          const assetGroup = this.selectedAssetGroups.find((assetGroup) => assetGroup.id == metadata.booking_detail.group_id);
          if (assetGroup) {
            if (value.book_detail.asset_id) {
              const typeName = this.assetTypes.find((d) => d.id == value.book_detail.asset_type);
              if (!arr.hasOwnProperty(value.book_detail.asset_id)) arr[value.book_detail.asset_id] = { group: assetGroup.name, name: `${get(typeName, 'name', '-')} - ${value.book_detail.asset_number}`, counter: 0 };
              arr[value.book_detail.asset_id].counter++;
            } else {
              if (!arr.hasOwnProperty(value.book_detail.vehicle_id)) arr[value.book_detail.vehicle_id] = { group: assetGroup.name, name: value.book_detail.vehicle_name, counter: 0 };
              arr[value.book_detail.vehicle_id].counter++;
            }
          }
          return arr;
        }, {})
        this.data = Object.values(this.data);
        this.isGenerate = true;
        this.isLoading = false;
      });
    },
  },
};
</script>
